<div class="allcp-form theme-primary mw500 auth-page register-merchant" ng-init="registerMerchantInit()">
	
	<!-- <div class="mv400 stepper-wrapper">
		<ul class="stepper" ng-class="registerStepMerchant == 6 ? 'success' : ''">
			<li ng-class="registerStepMerchant == 1 ? 'selected' : ''"><a href="#">1</a></li>
			<li ng-class="registerStepMerchant == 2 ? 'selected' : ''"><a href="#">2</a></li>
			<li ng-class="registerStepMerchant == 3 ? 'selected' : ''"><a href="#">3</a></li>
			<li ng-class="registerStepMerchant == 4 ? 'selected' : ''"><a href="#">4</a></li>
			<li ng-class="registerStepMerchant == 5 ? 'selected' : ''"><a href="#">5</a></li>
			<li ng-class="registerStepMerchant == 6 ? 'selected success' : 'hidden'"><a href="#">6</a></li>
		</ul>
	</div> -->
	<div class="panel mw500" >
		<div class="panel-body register pn mv10" ng-class="registerStepMerchant == 6 ? 'success' : ''">
			<form id="registerForm" name="registerPageForm" class="form-validation" role="form" ng-submit="registerMerchant()">

				<div class="inner-register-formf" ng-if="registerStepMerchant == 1">
					<a href="/" class="header-logo" target="__BLANK">
						<img src="/hodx-logo.svg" alt="HODXpress Login" class="img img-responsive" style="margin:0 auto;">
					</a>
					<h3 class="text-center">Double Your Orders </h3>
					<p>No obligation, you don’t pay if we don’t double your orders. Your account advisor will contact you shortly and take care of everything.
					</p>
					<div class="section">
						<input type="text" class="gui-input" placeholder="First Name" ng-model="registerForm.first_name" required>
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Last Name" ng-model="registerForm.last_name" required>
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Your Restaurant Name" ng-model="registerForm.company_name" required>
					</div>
					<!-- <div class="section">
						<input type="text" class="gui-input" placeholder="DBA Name" ng-model="registerForm.dba_name">
					</div> -->
					<div class="section">
						<input type="text" class="gui-input" placeholder="Phone Number" ng-model="registerForm.phone_number" required>
					</div>
					<!-- <div class="section">
						<input type="text" class="gui-input" placeholder="Tax Number" ng-model="registerForm.tax_number" required>
					</div> -->

					<div class="section">
						<input type="email" class="gui-input" placeholder="E-Mail" ng-model="registerForm.email" required>
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Street" ng-model="registerForm.address" >
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Apt, Suite, Building" ng-model="registerForm.address2">
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="City" ng-model="registerForm.city" >
					</div>
					<div class="section">
						<select ng-model="registerForm.state" class="gui-input" placeholder="State" >
							<option value="">Select State</option>
							<option value="{{ state.name }}" ng-repeat="state in states track by $index">{{ state.name }}</option>
						</select>
					</div>
					<div class="section">
						<input type="text" class="gui-input" placeholder="Zipcode" ng-model="registerForm.zipcode" >
					</div>
				</div>

				<div class="inner-register-form" ng-if="registerStepMerchant == 6">
					<div class="row text-center">
						<div class="col-md-12 text-center">
							<img src="/landing/img/sucess-small.svg" alt="">
						</div>
					</div>
					<h3 class="text-center">You have completed it successfully, your account will be approved and you will be informed as soon as possible. </h3>
					
				</div>
				<div class="section">
					<button 
						type="button" 
						ng-click="registerBackMerchant()" 
						ng-if="registerStepMerchant > 1 && registerStepMerchant != 6"
						ng-show="!signStatus"
						class="hod-button pull-left">
						<img src="/landing/img/arrow-left-line.svg" alt="">
					</button>
					<button 
						type="submit"
						ng-if="registerStepMerchant != 6 && !registerLoading"
						class="hod-button orange pull-right">
						Save
					</button>
					<button 
						type="button"
						ng-if="registerStepMerchant != 6 && registerLoading"
						ng-disabled="true"
						class="hod-button orange pull-right">Sending...</button>
				</div>
				<div class="clearfix"></div>
			</form>
		</div>


		<div class="modal info-box" id="successBox" role="dialog">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-body">
						<div class="success-box">
							<img src="/img/sucess-icon.svg">
							<h3 class="text-center">
								{{ successBoxMessage }}
							</h3>
							<a href="#" class="btn" data-dismiss="modal" ng-click="registerStepMerchant = 7">
								Done
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<a href="/sales/register?ref={{registerForm.ref }}" style="text-align: center;margin: 0 auto;margin-left: auto;display: block;width: 70%;" class="hod-button orange">Become a Sales Partner</a>

	<br> <br>
	<div class="col-md-12 footer-links driver-footer" style="margin:0px; padding:0px; margin-top:15px;width:100%">
		<div class="col-md-6 footer-copy">
			<p>© 2024 HODXpress</p>
		</div>
		<div class="col-md-6 footer-copy footer-links">
			<ul>
				<li>
					<a href="/driver-privacy-policy">Privacy</a>
				</li>
				<li>
					<a href="/driver-privacy-policy">Agreement</a>
				</li>
			</ul>
		</div>
	</div>

	<div class="modal" 
		id="docuSignModal" 
		tabindex="-1" 
		role="dialog" 
		aria-labelledby="docuSignModalLabel">
		<div class="modal-dialog modal-lg" style="width:100%;margin:0 auto" role="document">
			<div class="modal-content">
				<div class="modal-body">
					<iframe
					id="dswpf" 
					style="width: 100%; height: 700px;"
					ng-src="{{ docusignUrl | trusted }}"></iframe>
				</div>
				<!-- <div class="modal-footer">
					<a href="#" class="btn btn-primary" ng-click="completeDocusign()">Complete</a>
				</div> -->
			</div>
		</div>
	</div>
	
	
	<div class="modal" 
		id="authorization" 
		tabindex="-1" 
		role="dialog" 
		aria-labelledby="authorizationLabel">
		<div class="modal-dialog modal-lg" style="width:60%;margin:0 auto" role="document">
			<div class="modal-content">
				<div class="modal-body">
					<iframe 
						src="https://docs.google.com/viewer?url=https://hodxpress.com/Acknowledgement_and_Authorization.pdf&embedded=true" 
						width="100%" 
						height="100%" 
						style="width: 100%; height: 100%;" 
						frameborder="0" 
						scrolling="no">
					</iframe>
				</div>
				<div class="modal-footer">
					<a href="#" class="btn btn-primary" data-dismiss="modal">Close</a>
				</div>
			</div>
		</div>
	</div>
	<div class="modal" 
		id="disclosure" 
		tabindex="-1" 
		role="dialog" 
		aria-labelledby="disclosureLabel">
		<div class="modal-dialog modal-lg" style="width:60%" role="document">
			<div class="modal-content">
				<div class="modal-body">
					<iframe 
						src="https://docs.google.com/viewer?url=https://hodxpress.com/Disclosure.pdf&embedded=true" 
						width="100%" 
						height="100%" 
						style="width: 100%; height: 100%;" 
						frameborder="0" 
						scrolling="no">
					</iframe>
				</div>
				<div class="modal-footer">
					<a href="#" class="btn btn-primary" data-dismiss="modal">Close</a>
				</div>
			</div>
		</div>
	</div>
</div>
